export default __webpack_public_path__ + "static/media/Ballroll_00222.b5fa4352.png";